<template>
  <div>
    <div class="content">
      <el-card class="box-card">
        <div class="form-container">
          <el-form :model="searchForm" class="form" label-width="100px">
            <div class="form-section">
              <div class="section-title">基本信息</div>
              <el-row class="form-row" style="margin-bottom: 20px">
                <el-col :span="12">
                  <el-form-item label="对账年月" required>
                    <el-date-picker
                      v-model="searchForm.month"
                      type="month"
                      style="width: 100%"
                      placeholder="请选择年月"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-row" style="margin-bottom: 20px">
                <el-col :span="12">
                  <el-form-item label="表单名称" required>
                    <el-select
                      v-model="searchForm.sheetName"
                      placeholder="请选择表单名称"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in sheetOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="form-section">
              <div class="section-title">文件上传</div>
              <el-row>
                <el-col :span="24">
                  <div class="upload-container">
                    <el-upload
                      class="upload-demo"
                      drag
                      :auto-upload="false"
                      action="#"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      :before-upload="handleBeforeUpload"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      :on-change="handleChange"
                      accept=".xlsx,.xls"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div slot="tip" class="el-upload__tip">
                        只能上传Excel文件（.xlsx, .xls），且不超过100MB
                      </div>
                    </el-upload>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="form-section form-actions">
              <el-row>
                <el-col :span="24">
                  <div class="button-container">
                    <el-button type="primary" @click="handleUpload" :loading="uploading"
                      >开始上传</el-button
                    >
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { innerCheckBillUpload } from '@/api/billApi';
export default {
  name: 'InternalCheck',
  data() {
    return {
      searchForm: {
        month: '',
        sheetName: '',
      },
      sheetOptions: [
        { label: '资产专项明细', value: '资产专项明细', disabled: false },
        { label: '网络专项明细', value: '网络专项明细', disabled: false },
        { label: '服务器专项明细', value: '服务器专项明细', disabled: false },
      ],
      fileList: [],
      uploading: false,
    };
  },
  methods: {
    handleBeforeUpload(file) {
      if (!this.searchForm.month || !this.searchForm.sheetName) {
        this.$message.error('请先填写对账年月和表单名称');
        return false;
      }

      // 验证文件类型
      const isExcel =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel';
      if (!isExcel) {
        this.$message.error('只能上传Excel文件！');
        return false;
      }

      // 验证文件大小（100MB = 100 * 1024 * 1024 bytes）
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.error('文件大小不能超过100MB！');
        return false;
      }

      return true;
    },
    async handleUpload() {
      if (!this.searchForm.month || !this.searchForm.sheetName) {
        this.$message.error('请先填写对账年月和表单名称');
        return;
      }
      const currentFile = this.fileList[0];
      if (!currentFile || currentFile.status === 'fail') {
        this.$message.error('请先选择要上传的文件');
        return;
      }

      this.uploading = true;
      const loading = this.$loading({
        lock: true,
        text: '正在核对中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      try {
        // 构造上传参数
        const formData = new FormData();
        formData.append('file', this.fileList[0].raw);
        formData.append('Month', this.searchForm.month);
        formData.append('sheet_name', this.searchForm.sheetName);

        // 调用上传接口
        const response = await innerCheckBillUpload(formData);
        debugger;
        if (response.data.data) {
          let worksheetData;

          // 根据表单名称决定导出字段
          if (this.searchForm.sheetName === '资产专项明细') {
            // 资产专项明细使用特定字段
            worksheetData = response.data.data.map((row) => ({
              实际操作人: row.实际操作人 || '-',
              结单人: row.结单人 || '-',
              一级机房: row.一级机房 || '-',
              计价类型: row.计价类型 || '-',
              工单号: row.工单号 || '-',
              计费数值: row.计费数值,
              开始时间: row.开始时间 || '-',
              结束时间: row.结束时间 || '-',
              是否超时: row.是否超时 || '-',
              出入库类型: row.出入库类型 || '-',
              整机: row.整机 || '-',
              部件: row.部件 || '-',
              线材: row.线材 || '-',
              按箱: row.按箱 || '-',
              补贴类型: row.补贴类型 || '-',
              特定补贴次数: row.特定补贴次数,
              人数: row.人数,
              整机: row.整机 || '-',
              部件: row.部件 || '-',
              线材: row.线材 || '-',
              按箱: row.按箱 || '-',
              账单计费权重: row.账单计费权重 || '-',
              账单整机: row.账单整机 || '-',
              账单部件: row.账单部件 || '-',
              账单线材: row.账单线材 || '-',
              账单按箱: row.账单按箱 || '-',
              账单数是否异常: row.账单数是否异常 || '-',
              是否在对账单中: row.是否在对账单中 || '-',
            }));
          } else {
            // 其他表单保持原来的字段
            worksheetData = response.data.data.map((row) => ({
              实际操作人: row.实际操作人 || '-',
              结单人: row.结单人 || '-',
              一级机房: row.一级机房 || '-',
              计价类型: row.计价类型 || '-',
              工单号: row.工单号 || '-',
              计费数值: row.计费数值,
              结费单位: row.结费单位 || '-',
              开始时间: row.开始时间 || '-',
              结束时间: row.结束时间 || '-',
              是否超时: row.是否超时 || '-',
              补贴类型: row.补贴类型 || '-',
              特定补贴次数: row.特定补贴次数,
              人数: row.人数,
              均值: row.均值,
              账单系数: row.账单系数,
              账单数量: row.账单数量,
              账单数量是否异常: row.账单数量是否异常 || '-',
              是否在对账单中: row.是否在对账单中 || '-',
            }));
          }

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          // 设置列宽
          const colWidths = {};
          Object.keys(worksheetData[0]).forEach((key, index) => {
            colWidths[XLSX.utils.encode_col(index)] = { wch: 15 };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '内部核对');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `内部核对_${this.searchForm.month}_${this.searchForm.sheetName}_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
        loading.close();
        if (response.data.code === 200) {
          this.$message.success('上传成功');
          // 清空表单
          this.searchForm.sheetName = '';
          this.searchForm.month = '';
          this.fileList = [];
        } else if (response.data.code === 400) {
          this.$message.warning(response.data.msg || '上传失败');
        } else {
          this.$message.error(response.data.msg || '上传失败');
        }
      } catch (error) {
        console.error('上传错误：', error);
        this.$message.error('上传出错，请重试');
      } finally {
        loading.close();
        this.uploading = false;
      }
    },
    handlePreview(file) {
      console.log('预览文件：', file);
    },
    handleRemove(file, fileList) {
      console.log('移除文件：', file, fileList);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length +
          fileList.length} 个文件`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.$message.success('上传成功');
        // 清空表单
        this.searchForm.sheetName = '';
        this.searchForm.month = '';
      } else {
        this.$message.error(response.message || '上传失败');
      }
    },
    handleError(err, file, fileList) {
      this.$message.error('上传失败');
      console.error('上传失败：', err);
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  .box-card {
    margin-bottom: 20px;
  }
  .form-container {
    .form {
      max-width: 900px;

      .form-section {
        position: relative;
        border-radius: 4px;

        &:last-child {
          margin-bottom: 0;
        }

        .section-title {
          margin: 10px 0;
          padding-left: 10px;
          border-left: 3px solid #219aff;
          font-weight: normal;
        }

        &.form-actions {
          background: transparent;
          padding: 24px 0;

          .button-container {
            text-align: left;
            .el-button {
              min-width: 120px;
              padding: 12px 20px;
              font-size: 14px;
            }
          }
        }
      }
    }

    .upload-container {
      .el-upload {
        display: block;
      }

      .el-upload-dragger {
        width: 100%;
        height: 200px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-left: 40px;
        justify-content: center;
        border: 2px dashed #d9d9d9;
        border-radius: 6px;
        background: #fff;
        transition: all 0.3s;

        &:hover {
          border-color: #409eff;
          background: #f5f7fa;
        }

        .el-icon-upload {
          font-size: 48px;
          color: #409eff;
          margin-bottom: 16px;
        }

        .el-upload__text {
          font-size: 16px;
          color: #606266;

          em {
            color: #409eff;
            font-style: normal;
          }
        }
      }

      .el-upload__tip {
        margin-top: 12px;
        font-size: 13px;
        color: #909399;
        text-align: left;
      }
    }
  }
}
</style>
